import { useI18n } from "@/lib/i18n";
import { SectionHeading } from "@/components/Brand";

const KEYS = ["p1", "p2", "p3", "p4", "p5", "p6"];

export default function Privacy() {
  const { t } = useI18n();
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-8 lg:py-20" data-testid="privacy-page">
      <SectionHeading label="HR Creations" title={t("privacyPage.title")} sub={t("privacyPage.sub")} />
      <div className="mt-10 space-y-8">
        {KEYS.map((key) => (
          <section key={key} data-testid={`privacy-${key}`}>
            <h2 className="font-serif-display text-2xl text-[#8F3329]">{t(`privacyPage.${key}Title`)}</h2>
            <p className="mt-3 text-sm leading-relaxed text-[#5A5752] sm:text-base">
              {t(`privacyPage.${key}Body`)}
            </p>
          </section>
        ))}
        <p className="border-t border-[#C69A3B]/40 pt-6 text-sm text-[#5A5752]">
          {t("privacyPage.contact")}{" "}
          <a href="mailto:hrcreations90@gmail.com" className="text-[#8F3329] underline" data-testid="privacy-email">
            hrcreations90@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
}
